import { BusinessUnitDescribed, Dimension } from 'src/@enums'
import { BusinessUnitShortType } from 'src/@types'
import { gaEvent, getBusinessUnitDescribed, getDimensionByUnit } from 'src/utils'

/**
 * Enum de Steps de coleta de dados parcial
 * @enum
 * {@link CustomerPartialIdentificationEvent}
 *
 */
export enum Steps {
  start = 'start',
  finish = 'finish',
}

/**
 * Parâmetro para {@link customerPartialIdentificationEvent}
 */
export type CustomerPartialIdentificationEvent = BusinessUnitShortType & {
  backOfficeId: string
  step: `${Steps}`
  customerId?: string
}

export const baseEvent = (businessUnitDescribed: `${BusinessUnitDescribed}`) => ({
  event: 'ga-event',
  'event-category': `minhaloja:${businessUnitDescribed}:cadastro-parcial`,
  'event-action': 'callback:pedido',
})

/**
 * @deprecated evitar usar, não está no padrão GA4
 * [TARGET]: identificar fluxo de coleta parcial de dados do cliente final
 *
 * [CONTEXTO]: a coleta parcial acontece em outro domínio após a finalização do pedido,
 * deve-se registrar o início da coleta com o identificador do pedido, e o final com identificação do cliente final.
 *
 * [REGRAS]:
 *
 * - step == start -> usado antes do redirecionamento de saída para o domínio para o fluxo de coleta parcial
 * - step == finish -> usado após a finilização da coleta parcial e redirecionamento de retorno para aplicação
 *
 * @param config - Objeto com dados do evento
 */
export const customerPartialIdentificationEvent = ({
  backOfficeId,
  businessUnit,
  step,
  customerId,
}: CustomerPartialIdentificationEvent) => {
  const businessUnitDescribed = getBusinessUnitDescribed(businessUnit)
  if (step === Steps.start) {
    gaEvent({
      ...baseEvent(businessUnitDescribed),
      'event-label': `${backOfficeId}:start`,
    })
    return
  }

  gaEvent({
    ...baseEvent(businessUnitDescribed),
    'event-label': `${backOfficeId}:finish`,
    [getDimensionByUnit(Dimension.CF_ID, businessUnit)]: customerId,
  })
}
